//% Libs
import {Routes, Route} from "react-router-dom";

//% Component
import CategoriesPreview from "../categories-preview/categories-preview.component";
import Category from "../category/category.component";

//% Styles
import "./shop.styles.scss";

const Shop = () => {
  return (
    <Routes>
      <Route index element={<CategoriesPreview />} />
      <Route path=":category" element={<Category />} />
    </Routes>
  );
};

export default Shop;
